<template>
  <div id="form-akses">
    <form action="#">
      <div class="form-group">
        <div class="row">
          <div class="col-md-8">
            <label for="">News Trend </label>
          </div>
          <div class="col-md-4">
            <div class="form-check form-check-inline switch">
              <input
                type="checkbox"
                :checked="isNewstrend"
                id="SwitchTrenAkses"
                @click="toggleAkses('newstrend')"
              />
              <label for="SwitchTrenAkses">
                {{ isNewstrend ? "Non Aktifkan" : "Aktifkan" }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <label for="">Cleansing </label>
          </div>
          <div class="col-md-4">
            <div class="form-check form-check-inline switch">
              <input
                type="checkbox"
                :checked="is_clean"
                id="SwitchCleansingAkses"
                @click="toggleAkses('datacleansing')"
              />
              <label for="SwitchCleansingAkses">
                {{ is_clean ? "Non Aktifkan" : "Aktifkan" }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;
export default {
  name: "modal_edit_akses",
  props: {
    data: Array,
  },
  data() {
    return {
      isNewstrend: this.data[0].newstrend == "manage" ? true : false,
      is_clean: this.data[0].datacleansing == "manage" ? true : false,
    };
  },
  methods: {
    toggleAkses: function (name) {
      let api = process.env.VUE_APP_API_URL + "users-capabilites";
      let toggle = "off";
      if (this.$(event.target)[0].checked == true) {
        toggle = "manage";
      }
      let params = {
        _id: this.data[0].id_user,
        value: toggle,
        name: name,
      };
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
            this.$("#modalSlideUp").modal("hide");
            this.$parent.$parent.getUser();
          }
        })
        .catch(() => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
  },
};
</script>